//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchInput from "@/components/SearchInput";
import ColumnsSelect from '@/components/ColumnsSelect'
import apiOriginacion from "../../api/promotores/originacion.api";

export default {
  components: { SearchInput, ColumnsSelect },
  data() {
    return {
        visible_columns: [
        'id', 'nombre', 'importe', 'autorizado', 'plazo', 'rol_nombre', 'promotor_nombre', 'created_at', 'updated_at'
       ],
       columns: [
        { name: "id", label: "ID", field: "id", style: "width: 10px", sortable: true },
        { name: "nombre",label: "Nombre",field: "nombre",align: "left",classes: "bg-grey-2 ellipsis",style: "width: 350px",headerClasses: "bg-primary text-white",},
        { name: "importe",label: "Monto solicitado",field: "importe_solicitado",sortable: true,format: this.currency,},
        { name: "autorizado",label: "Monto autorizado",field: "ejercido.monto_autorizado_comite",sortable: true,format: this.currency,},
        { name: "plazo", label: "Plazo", field: "plazo", sortable: true, format: this.formatPlazo },
        { name: "email", label: "Email", field: "email" },
        { name: "telefono", label: "Télefono", field: "telefono" },
        { name: "rol_nombre", label: "Grupo", field: "rol_nombre", sortable: true },
        { name: "promotor_nombre", label: "Promotor", field: "promotor_nombre", sortable: true, },
        { name: "created_at", label: "Creación", field: "created_at", sortable: true, },
        { name: "updated_at", label: "Actualizado", field: "updated_at", sortable: true, },
      ],
      contactos: [],
      loading: false,
      filter: null,
    }
  },
  mounted() {
  this.loadContactos();
  },
  methods: {
    async loadContactos() {
      try {
        this.loading = true
        this.contactos = await apiOriginacion.all();
        console.log(this.contactos)
      } finally {
        this.loading = false
      }
    },
    formatPlazo(plazo) {
      return this.pluralize(plazo, ["año", "años"])
    },
  }
};
